import { setDoc } from "firebase/firestore";
import { GenericSwitch } from "../../components/elements/Switch";
import { showMessage } from "../../components/message/GenericMessage";
import { activeColumn, createdColumn } from "../../constants/objects";
import { sPending, sResolved } from "../../constants/strings";
import { STATUS_RESOLVED, TEMPLATES } from "../../constants/webapp";
import { useAppContext } from "../../context/useAppContext";
import { FormLayoutHandler } from "../../pages/layouts/FormLayoutHandler";
import { dateTimeFormat } from "../../utils/formatter";
import { capitalize, stringfy } from "../../utils/helpers";
import { DescWrapper } from "../useProducts";

export function getTicketStatus(key) {
  let color, status;
  switch (key) {
    case STATUS_RESOLVED:
      status = sResolved;
      color = "green";
      break;

    default:
      status = sPending;
      break;
  }
  return { color, status };
}

export function ActionsUpdate(item, data) {
  if (item.docRef && item.status !== data.status) {
    setDoc(item.docRef, data, { merge: true }).then(() =>
      showMessage("Updated Successfully")
    );
  }
}

export const useTemplates = () => {
  const { contextData } = useAppContext();

  const tableData = (data) => [
    ...data.map((item) => {
      const { type, timestamp, title, body, active, docRef } = item || {};
      const row = {
        ...item,
        template: (
          <div>
            <p>{title}</p>
            <DescWrapper className="font11 thin lightColor">{body}</DescWrapper>
          </div>
        ),
        type: capitalize(stringfy(type)),
        timestamp: dateTimeFormat(timestamp),
        active: <GenericSwitch end checked={active} docRef={docRef} />,
        // actions: (
        //   <Actions
        //     actions={[
        //       {
        //         action:
        //           status === PENDING ? "Mark as Resolved" : "Mark as Pending",
        //         click: () =>
        //           ActionsUpdate(item, {
        //             status: status === PENDING ? STATUS_RESOLVED : PENDING,
        //           }),
        //       },
        //     ]}
        //   />
        // ),
        onclick: () =>
          contextData.showGlobalDrawer({
            component: (
              <FormLayoutHandler
                key={TEMPLATES}
                source={TEMPLATES}
                data={item}
              />
            ),
            title: "Update Template",
          }),
      };
      return row;
    }),
  ];

  const tableColumns = () => [
    { id: "template", align: "left" },
    { id: "type", title: "type" },
    activeColumn,
    createdColumn,
    // actionsColumn,
  ];

  const form = {
    source: TEMPLATES,
  };

  return { tableColumns, tableData, form };
};
